import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "white--text" }
const _hoisted_2 = { style: {"font-size":"12pt"} }
const _hoisted_3 = { style: {"font-size":"12pt"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    style: {"background-color":"transparent"},
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, {
        class: _normalizeClass(
                !_ctx.$vuetify.display.mobile
                    ? 'title font-weight-regular justify-space-between'
                    : 'title font-weight-regular pa-1'
            )
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.wizardStepTitle), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_window, {
        modelValue: _ctx.wizardStep,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.wizardStep) = $event)),
        touchless: "",
        style: {"min-height":"27vh","min-width":"40vw"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: -1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, { lines: "two" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: "mb-2 oss-list-item",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {
                                _ctx.wizardMode = 'Manual';
                                _ctx.wizardStep = 0;
                            }, ["stop"]))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode("$fa-edit")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode("Créer")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode("Créer un Z de caisse à la main")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        class: _normalizeClass(
                                !_ctx.$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item'
                                    : 'mb-2 px-2 oss-list-item'
                            ),
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
                                _ctx.wizardMode = 'UploadDocument';
                                _ctx.wizardStep = 6;
                            }, ["stop"]))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("$oss-upload")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode("Importer")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode(" Importer un fichier sur la plateforme : (Z de caisse ou facture d'une plateforme de livraison) ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    subheader: "",
                    lines: "two",
                    modelValue: _ctx.period,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.period) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (item, i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: i,
                          class: _normalizeClass(["oss-list-item mb-2", {
                                active: _ctx.period === item.key,
                                inactive: _ctx.period !== item.key,
                            }]),
                          onClick: ($event: any) => (_ctx.period = item.key),
                          "data-cy": 'zTillReceipt-period-' + item.key
                        }, {
                          prepend: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(item.onegram), 1)
                          ]),
                          append: _withCtx(() => [
                            (_ctx.period === item.key)
                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 0,
                                  icon: "$mdi-radiobox-marked"
                                }))
                              : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 1,
                                  icon: "$mdi-radiobox-blank"
                                }))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.value), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "data-cy", "class"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_v_col, {
                        cols: "12",
                        key: _ctx.period
                      }, {
                        default: _withCtx(() => [
                          (_ctx.period === 'WE')
                            ? (_openBlock(), _createBlock(_component_v_date_picker_wrapper, {
                                key: 0,
                                modelValue: _ctx.week,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.week) = $event)),
                                range: "",
                                locale: "fr-FR",
                                "full-width": "",
                                landscape: "",
                                "allowed-dates": _ctx.allowedDates,
                                class: "elevation-0",
                                color: "secondary",
                                "first-day-of-week": "1",
                                scrollable: ""
                              }, null, 8, ["modelValue", "allowed-dates"]))
                            : (_openBlock(), _createBlock(_component_v_date_picker_wrapper, {
                                key: 1,
                                modelValue: _ctx.date,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.date) = $event)),
                                locale: "fr-FR",
                                "full-width": "",
                                landscape: "",
                                "allowed-dates": _ctx.allowedDates,
                                type: _ctx.month ? 'month' : 'date',
                                class: "elevation-0",
                                color: "secondary",
                                "first-day-of-week": "1",
                                scrollable: ""
                              }, null, 8, ["modelValue", "allowed-dates", "type"]))
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  }),
                  (_ctx.verifDate)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorPeriodMessage), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "py-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_FreeTag, {
                            companyTags: _ctx.allCompanyTags,
                            company: _ctx.company,
                            "document-type": "ZTILL_RECEIPT",
                            onUpdateTags: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateTags($event)))
                          }, null, 8, ["companyTags", "company"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list, { lines: "two" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomes, (income, i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: i,
                          class: _normalizeClass(
                                !_ctx.$vuetify.display.mobile
                                    ? 'mb-2 py-2 oss-list-item'
                                    : 'mb-2 pa-2 oss-list-item'
                            )
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_trash, {
                              onClick: ($event: any) => (_ctx.deleteCategory(income)),
                              size: "x-small"
                            }, null, 8, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getAccountableAccountDescription(income.accountableAccount)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getSubTitle(income)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wizardStep = 3)),
                        elevation: "0",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createTextVNode(" Ajouter une recette ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "py-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            modelValue: _ctx.income.accountableAccount,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.income.accountableAccount) = $event)),
                            items: _ctx.salesAccountableAccounts,
                            label: "Type de recette",
                            "item-value": "name",
                            outlined: "",
                            density: "compact",
                            "item-title": (item) => item.description
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            modelValue: _ctx.income.vatRate,
                            "onUpdate:modelValue": [
                              _cache[8] || (_cache[8] = ($event: any) => ((_ctx.income.vatRate) = $event)),
                              _cache[9] || (_cache[9] = ($event: any) => (_ctx.VATRate(_ctx.income, $event, false)))
                            ],
                            items: _ctx.vatRates,
                            label: "Taux de TVA",
                            outlined: "",
                            density: "compact"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            modelValue: _ctx.income.grossAmount,
                            "onUpdate:modelValue": [
                              _cache[10] || (_cache[10] = ($event: any) => ((_ctx.income.grossAmount) = $event)),
                              _cache[11] || (_cache[11] = ($event: any) => (_ctx.TTCPrice(_ctx.income, false)))
                            ],
                            label: "Montant TTC",
                            outlined: "",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            modelValue: _ctx.income.freeAmount,
                            "onUpdate:modelValue": [
                              _cache[12] || (_cache[12] = ($event: any) => ((_ctx.income.freeAmount) = $event)),
                              _cache[13] || (_cache[13] = ($event: any) => (_ctx.onFreeAmountChanged()))
                            ],
                            label: "Dont montant offert",
                            outlined: "",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pb-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_2, "HT : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.income.netAmount, undefined)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pb-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_3, "TVA : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.income.vatAmount, undefined)), 1)
                        ]),
                        _: 1
                      }),
                      (
                                _ctx.currentUser.profile && _ctx.currentUser.profile.configuration.tag.write
                            )
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.wizardStep === 3)
                                ? (_openBlock(), _createBlock(_component_FreeTag, {
                                    key: 0,
                                    companyTags: _ctx.allCompanyTags,
                                    document: _ctx.income.document,
                                    onUpdateTags: _ctx.onUpdateTag
                                  }, null, 8, ["companyTags", "document", "onUpdateTags"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "py-0" }, {
                default: _withCtx(() => [
                  (_ctx.commission)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        class: "d-flex align-center my-2 mx-2",
                        style: {"background-color":"#fff","border-radius":"30px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: _ctx.$vuetify.display.mobile ? '12' : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                outlined: "",
                                "hide-details": true,
                                items: _ctx.vatRates,
                                "item-value": "value",
                                "single-line": "",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.VATRate(_ctx.commission, $event))),
                                "model-value": 
                                    _ctx.commission.vatType
                                        ? _ctx.commission.vatRate.toString() + _ctx.commission.vatType
                                        : _ctx.commission.vatRate
                                ,
                                density: "compact"
                              }, null, 8, ["items", "model-value"])
                            ]),
                            _: 1
                          }, 8, ["cols"]),
                          _createVNode(_component_v_col, {
                            cols: _ctx.$vuetify.display.mobile ? '12' : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_text_field_filled, {
                                label: "HT",
                                suffix: "€",
                                "hide-details": "",
                                disabled: "",
                                "model-value": _ctx.commission.netAmount
                              }, null, 8, ["model-value"])
                            ]),
                            _: 1
                          }, 8, ["cols"]),
                          _createVNode(_component_v_col, {
                            cols: _ctx.$vuetify.display.mobile ? '12' : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_text_field_filled, {
                                label: "TVA",
                                suffix: "€",
                                "hide-details": "",
                                disabled: "",
                                "model-value": _ctx.commission.vatAmount
                              }, null, 8, ["model-value"])
                            ]),
                            _: 1
                          }, 8, ["cols"]),
                          _createVNode(_component_v_col, {
                            cols: _ctx.$vuetify.display.mobile ? '12' : '',
                            class: "d-flex align-center justify-start"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_text_field_filled, {
                                label: "TTC",
                                modelValue: _ctx.commission.grossAmount,
                                "onUpdate:modelValue": [
                                  _cache[15] || (_cache[15] = ($event: any) => ((_ctx.commission.grossAmount) = $event)),
                                  _cache[16] || (_cache[16] = ($event: any) => (_ctx.TTCPrice(_ctx.commission)))
                                ],
                                suffix: "€",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["cols"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "py-0" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_row, {
                      "no-gutters": "",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "pa-1 d-flex align-center justify-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select_filled, {
                              modelValue: item.name,
                              "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                              items: _ctx.transactionAccountableAccounts,
                              label: "Type de transaction",
                              "item-title": _ctx.getDescription,
                              "item-value": "name",
                              outlined: "",
                              "single-line": "",
                              "hide-details": true,
                              density: "compact"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { class: "pa-1 d-flex align-center justify-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              suffix: "€",
                              dense: "",
                              "single-line": "",
                              "hide-details": true,
                              modelValue: item.amount,
                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "pa-1 d-flex align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.transactions.length > 1)
                              ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.deleteTransaction(item)),
                                  size: "x-small"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pa-1 d-flex align-center justify-end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_add_icon, {
                            class: "mx-2 my-2",
                            size: "x-small",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addTransaction()))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.errorText)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        class: "align-self-end",
                        type: _ctx.alertType,
                        "model-value": true,
                        variant: "tonal"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorText), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "py-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadDocuments, {
                    showFirstPrevious: false,
                    companyId: _ctx.companyId,
                    documentType: 'ZTILL_RECEIPT',
                    multiple: true,
                    actions: _ctx.actions,
                    onFile: _ctx.linkFile
                  }, null, 8, ["companyId", "actions", "onFile"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}